__webpack_require__.p = "https://cribwiz.com/";